/* ==========================================================================
 * WallKoala - shared variant reader  v2.0
 * Size / Framing Type come from the SHOPIFY VARIANT (they drive price),
 * not from LPO. Read the theme's own picker first, fall back to the product
 * JSON keyed off the selected variant id. Matched BY OPTION NAME, never by
 * position - the live product is "Size / Framing Type" while the sandbox is
 * "Framing Type / Size".
 * ========================================================================== */
(function(){
var DEBUG=true;
function log(){if(DEBUG&&window.console)console.debug.apply(console,['[wk-var]'].concat([].slice.call(arguments)))}
function form(){return document.querySelector('form[action*="/cart/add"]')}
function variantId(){var f=form();var i=f&&f.querySelector('[name="id"]');return i&&i.value?String(i.value):null}

/* --- A. the theme's own variant picker (Impulse: fieldset.variant-input-wrap[name]) --- */
function fromTheme(){
  var o={},seen=0;
  [].forEach.call(document.querySelectorAll('fieldset[name],[data-option-name],select[data-index],select[name^="options"]'),function(n){
    var key=(n.getAttribute('name')||n.getAttribute('data-option-name')||'').trim();
    if(!key){   /* dropdown mode: <select data-index> carries no name - use its label */
      var w=n.closest&&n.closest('.variant-wrapper');
      var lbl=w&&(w.querySelector('.variant__label')||w.querySelector('label'));
      key=((lbl&&lbl.textContent)||'').replace(/\s+/g,' ').trim();
    }
    if(!key||/^id$/i.test(key))return;
    var v=null;
    var c=n.querySelector&&n.querySelector('input[type=radio]:checked,input[type=checkbox]:checked');
    if(c)v=c.value;
    else if(n.tagName==='SELECT'&&n.value)v=n.value;
    else{var s=n.querySelector&&n.querySelector('select');if(s&&s.value)v=s.value}
    if(v){o[key.toLowerCase()]=String(v).trim();seen++}
  });
  return seen?o:null;
}

/* --- B. /products/<handle>.js keyed off the selected variant id --- */
var PJ=null,pjTried=false,onReady=[];
function handle(){
  var m=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product;
  if(m&&m.handle)return m.handle;
  var l=document.querySelector('link[rel=canonical]');
  var g=l&&String(l.href).match(/\/products\/([^/?#]+)/);if(g)return g[1];
  g=location.pathname.match(/\/products\/([^/?#]+)/);if(g)return g[1];
  var t=document.querySelector('[data-product-handle]');
  return t?t.getAttribute('data-product-handle'):null;
}
function loadPJ(){
  if(pjTried)return;pjTried=true;
  var h=handle();if(!h){log('no handle');return}
  fetch('/products/'+h+'.js',{credentials:'same-origin'})
    .then(function(r){return r.ok?r.json():null})
    .then(function(j){if(!j||!j.variants)return;PJ=j;log('product json',j.handle,j.variants.length+' variants');
      onReady.splice(0).forEach(function(f){try{f()}catch(e){}})})
    .catch(function(e){log('product json failed',e)});
}
function fromJSON(){
  if(!PJ)return null;
  var id=variantId();if(!id)return null;
  var v=null,i;
  for(i=0;i<PJ.variants.length;i++){if(String(PJ.variants[i].id)===id){v=PJ.variants[i];break}}
  if(!v)return null;
  var names=(PJ.options||[]).map(function(x){return typeof x==='string'?x:(x&&x.name)||''});
  var o={};
  for(i=0;i<names.length;i++){if(names[i]&&v.options[i])o[String(names[i]).toLowerCase()]=String(v.options[i]).trim()}
  return o;
}

/* --- C. last resort: LPO-rendered options (only exist when Variant options is ON) --- */
function fromLPO(){
  var o={},n=0;
  [].forEach.call(document.querySelectorAll('[data-option]'),function(e){
    var key=(e.getAttribute('data-option')||'').toLowerCase();
    if(!/size|fram|format/.test(key)||/print/.test(key))return;
    if(e.hasAttribute('data-wk-frame-control'))return;  /* that option is driven BY the variant */
    var v=null,s=e.querySelector('select');
    if(s&&s.value){var op=s.options[s.selectedIndex];v=(op&&(op.textContent||op.value))||s.value}
    else{var c=e.querySelector('input[type=radio]:checked');if(c){var l=c.closest('label');v=(l&&l.textContent)||c.value}}
    if(v){o[key]=String(v).trim();n++}
  });
  return n?o:null;
}

function pick(o,re){if(!o)return null;for(var k in o){if(re.test(k))return o[k]}return null}
/* match on the VALUE instead of the option name - the framing option is called
   "Framing Type" on most products and "Format" on others, but its values always
   say stretched / floating */
function pickVal(o,re){if(!o)return null;for(var k in o){if(re.test(o[k]))return o[k]}return null}

/* Returns {size:"20cm (8'') x 30cm (12'')", framing:"Floating Framed", src:"theme"} or null */
function read(){
  var srcs=[['theme',fromTheme],['json',fromJSON],['lpo',fromLPO]];
  var size=null,fram=null,src=[];
  for(var i=0;i<srcs.length;i++){
    var o=srcs[i][1]();if(!o)continue;
    if(!size){var s=pick(o,/size/);if(s&&/\d+\s*cm/i.test(s)){size=s;src.push(srcs[i][0]+':size')}}
    if(!fram){var f=pick(o,/fram|format/)||pickVal(o,/stretch|float/);if(f){fram=f;src.push(srcs[i][0]+':fram')}}
    if(size&&fram)break;
  }
  if(!PJ&&(!size||!fram))loadPJ();
  return size?{size:size,framing:fram,src:src.join(',')}:null;
}

/* Fire wk:variant when the selected variant changes (covers theme clicks AND
   section re-renders, which plain event listeners miss). */
var lastId=null,lastKey=null;
function tick(){
  var id=variantId(),r=read();
  var key=id+'|'+(r?r.size+'|'+r.framing:'');
  if(key===lastKey)return;
  lastId=id;lastKey=key;
  log('variant',id,r&&r.size,r&&r.framing,'via',r&&r.src);
  window.dispatchEvent(new CustomEvent('wk:variant',{detail:r||{}}));
}
document.addEventListener('change',function(){setTimeout(tick,60)},true);
document.addEventListener('click',function(){setTimeout(tick,180)},true);
setInterval(tick,700);
loadPJ();tick();
window.WKVariant={read:read,variantId:variantId,tick:tick,_theme:fromTheme,_json:fromJSON,_lpo:fromLPO,
  get productJson(){return PJ}};
})();
/* ==========================================================================
 * WallKoala custom canvas - bridge v2.0
 * Variant Size + LPO Orientation -> PrintSize (crop ratio) -> upload hint
 * Size now comes from the Shopify variant via WKVariant, because Size and
 * Framing Type stay native options (they drive price). FAILS SAFE: if the
 * size cannot be determined it writes nothing rather than a wrong ratio.
 * ========================================================================== */
(function(){
var C={size:'Size',ori:'Orientation',dim:'PrintSize',up:'Photo',land:['landscape'],
tiers:[[40,150],[70,120],[100,100],[9999,80]],soft:0.75,debug:true};
function log(){if(C.debug&&window.console)console.debug.apply(console,['[wk]'].concat([].slice.call(arguments)))}
function el(n){return document.querySelector('[data-option="'+n+'"]')}
function dins(){var e=el(C.dim);if(!e)return[];return [].slice.call(e.querySelectorAll('input')).filter(function(i){return i.type!=='hidden'})}
function parse(s){if(!s)return null;var m=String(s).match(/(\d+(?:\.\d+)?)\s*cm/gi);if(!m||m.length<2)return null;var a=parseFloat(m[0]),b=parseFloat(m[1]);return(a>0&&b>0)?[Math.min(a,b),Math.max(a,b)]:null}
function isLand(v){if(!v)return false;var s=String(v).toLowerCase();return C.land.some(function(k){return s.indexOf(String(k).toLowerCase())>-1})}
function ppi(l){for(var i=0;i<C.tiers.length;i++){if(l<=C.tiers[i][0])return C.tiers[i][1]}return 80}
function need(w,h){var p=ppi(Math.max(w,h));return{p:p,w:Math.round(w/2.54*p),h:Math.round(h/2.54*p)}}
function val(n){var e=el(n);if(!e)return null;var s=e.querySelector('select');if(s&&s.value){var o=s.options[s.selectedIndex];return((o&&(o.textContent||o.value))||s.value).trim()}var c=e.querySelector('input[type=radio]:checked,input[type=checkbox]:checked');if(c){var l=c.closest('label');return((l&&l.textContent)||c.value||'').trim()}var t=e.querySelector('input[type=text],input[type=hidden]');if(t&&t.value)return t.value.trim();var a=e.querySelector('[aria-checked=true],.selected,.active');return a?(a.getAttribute('data-value')||a.textContent||'').trim():null}
/* React-controlled inputs ignore a plain .value assignment - go through the prototype setter */
function setv(i,v,hard){if(!i)return;var s=String(v);if(hard&&i.focus){try{i.focus()}catch(e){}}
try{var d=Object.getOwnPropertyDescriptor(Object.getPrototypeOf(i),'value');if(d&&d.set){d.set.call(i,s)}else{i.value=s}}catch(e){i.value=s}
i.dispatchEvent(new Event('input',{bubbles:true}));i.dispatchEvent(new Event('change',{bubbles:true}));
if(hard){i.dispatchEvent(new Event('keyup',{bubbles:true}));if(i.blur){try{i.blur()}catch(e){}}}}
var last=null,up=null,S={},timer=null;
function writeDim(w,h,t){t=t||0;var ins=dins();if(ins.length<2){log('dim input count',ins.length);return}
if(String(ins[0].value)===String(w)&&String(ins[1].value)===String(h)){log('dim ok',w+'x'+h,'pass'+t);return}
var hard=t>0;
if(String(ins[0].value)!==String(w))setv(ins[0],w,hard);
var i2=dins();if(i2.length>1&&String(i2[1].value)!==String(h))setv(i2[1],h,hard);
if(t<8){clearTimeout(timer);timer=setTimeout(function(){writeDim(w,h,t+1)},130)}else{log('dim write gave up',w+'x'+h)}}
function box(){var h=el(C.up)||el(C.dim);if(!h)return null;var b=h.querySelector('[data-wk-hint]');
if(!b){b=document.createElement('div');b.setAttribute('data-wk-hint','');b.style.cssText='margin-top:8px;font-size:13px;line-height:1.6;color:#6b6b6b';h.appendChild(b)}return b}
function hint(){var b=box();if(!b||!S.w)return;var n=need(S.w,S.h);var s='<div>Recommended minimum for this size: <b>'+n.w+' x '+n.h+'</b> px (about '+n.p+' PPI).</div>';
if(up){var soft=C.soft;if(up.w<n.w*soft||up.h<n.h*soft){s+='<div style="margin-top:4px;color:#845309">Your image is '+up.w+' x '+up.h+' px, below the recommended size. You can still order, but fine detail may be lost when enlarged.</div>'}
else{s+='<div style="margin-top:4px;color:#15803D">Image resolution is suitable for this size.</div>'}}
b.innerHTML=s}
function apply(r){
var V=window.WKVariant&&window.WKVariant.read();
var sv=(V&&V.size)||val(C.size);
if(!sv){log('no size yet - writing nothing',r);return}
var d=parse(sv);if(!d){log('size parse fail',r,sv);return}
var L=isLand(val(C.ori));S.sizeLabel=sv;S.landscape=L;S.w=L?d[1]:d[0];S.h=L?d[0]:d[1];
var k=S.w+'x'+S.h;if(k!==last){last=k;log('apply',k,r);writeDim(S.w,S.h,0)}hint()}
document.addEventListener('change',function(e){var t=e.target;if(!t||t.type!=='file'||!t.files||!t.files.length)return;
var f=t.files[0];if(!/^image\//.test(f.type))return;var u=URL.createObjectURL(f),im=new Image();
im.onload=function(){up={w:im.naturalWidth,h:im.naturalHeight};URL.revokeObjectURL(u);hint()};
im.onerror=function(){URL.revokeObjectURL(u)};im.src=u},true);
window.addEventListener('wk:variant',function(){apply('variant')});
window.addEventListener('option:changed',function(e){var n=e&&e.detail&&e.detail.name;if(!n||n===C.size||n===C.ori)apply('changed:'+n)});
window.addEventListener('options:rendered',function(){last=null;apply('rendered')});
window.WKBridge={cfg:C,state:S,apply:apply,dins:dins};
apply('init');
var tries=0;(function boot(){apply('boot');if(++tries<40)setTimeout(boot,400)})();
setInterval(function(){apply('tick')},1500);
})();
/* WallKoala Phase 2 - live preview layer v2.2 (CSS 3D, no assets)
   Size + Framing Type read from the Shopify variant (WKVariant); frame colour
   from the existing LPO option. Face 0.55cm, gap 0.5cm, frame depth 4.5cm.
   Edge treatments: Mirrored Wrap / Image Wrap / White Edge / Black Edge. */
(function(){
var C={size:'Size',ori:'Orientation',edge:'EdgeTreatment',fram:'Framing Type',up:'Photo',
depthCm:3.8,gapCm:0.5,frameCm:0.55,frameDepthCm:4.5,ry:20,rx:5,ryBoost:12,ryRefCm:30,ryPerCm:0.12,stageH:340,texture:true,debug:true};
var KW=[[/black|noir|onyx/i,'#1C1A18'],[/white|ivory|blanc/i,'#F2EFE9'],[/birch|champagne|gold|brass/i,'#C9A96A'],
[/oak|natural|wood|maple/i,'#B9895A'],[/walnut|espresso|dark\s*wood/i,'#5C3D28'],[/silver|chrome|alumin/i,'#B8BCC0'],
[/grey|gray|graphite/i,'#6E6E6E']];
var el={},built=false,lastKey='';
function log(){if(C.debug&&window.console)console.debug.apply(console,['[wk-pv]'].concat([].slice.call(arguments)))}
function opt(n){return n?document.querySelector('[data-option="'+n+'"]'):null}
function val(n){return valOf(opt(n))}
function valOf(e){if(!e)return null;var s=e.querySelector('select');if(s&&s.value){var o=s.options[s.selectedIndex];return((o&&(o.textContent||o.value))||s.value).trim()}var c=e.querySelector('input[type=radio]:checked,input[type=checkbox]:checked');if(c){var l=c.closest('label');return((l&&l.textContent)||c.value||'').trim()}var t=e.querySelector('input[type=text],input[type=hidden]');if(t&&t.value)return t.value.trim();var a=e.querySelector('[aria-checked=true],.selected,.active');return a?(a.getAttribute('data-value')||a.getAttribute('title')||a.textContent||'').trim():null}
/* Locate the EXISTING frame-colour option: known names first, then any option whose name has fram+colo(u)r, then any colour option */
function fcHost(){var i,n,a=document.querySelectorAll('[data-option]');
var m=document.querySelector('[data-wk-frame-control]');if(m)return m;   /* unified control wins */
var names=['Framing Color','Framing Colour','Frame Color','Frame Colour','FrameColour','FrameColor','FramingColor'];
for(i=0;i<names.length;i++){var e=opt(names[i]);if(e)return e}
for(i=0;i<a.length;i++){n=a[i].getAttribute('data-option')||'';if(/fram/i.test(n)&&/colou?r/i.test(n))return a[i]}
for(i=0;i<a.length;i++){n=a[i].getAttribute('data-option')||'';if(/colou?r/i.test(n)&&!/edge/i.test(n))return a[i]}
/* the option may carry no "colour" in its name at all, e.g. "Framing option" */
for(i=0;i<a.length;i++){n=a[i].getAttribute('data-option')||'';if(/fram/i.test(n))return a[i]}
return null}
function selNode(h){if(!h)return null;var c=h.querySelector('input[type=radio]:checked,input[type=checkbox]:checked');if(c)return c.closest('label')||c.parentElement;return h.querySelector('[aria-checked=true],.selected,.active,[class*="selected"],[class*="active"]')}
function parseRGB(s){var m=String(s||'').match(/rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?/);return m?{r:+m[1],g:+m[2],b:+m[3],a:m[4]===undefined?1:+m[4]}:null}
/* Fallback: read the actual colour off the selected swatch, so any palette you configure just works */
function swatchRGB(h){var n=selNode(h);if(!n)return null;var list=[].slice.call(n.querySelectorAll('*')).concat([n]),i,p;
for(i=0;i<list.length;i++){var r=list[i].getBoundingClientRect();if(r.width<6||r.width>64)continue;
p=parseRGB(getComputedStyle(list[i]).backgroundColor);if(p&&p.a>0.15)return p}
for(i=0;i<list.length;i++){p=parseRGB(getComputedStyle(list[i]).backgroundColor);if(p&&p.a>0.15)return p}return null}
function hex2rgb(h){return{r:parseInt(h.substr(1,2),16),g:parseInt(h.substr(3,2),16),b:parseInt(h.substr(5,2),16),a:1}}
function sh(p,k){var f=function(v){return Math.max(0,Math.min(255,Math.round(k>0?v+(255-v)*k:v*(1+k))))};return'rgb('+f(p.r)+','+f(p.g)+','+f(p.b)+')'}
function frameSkin(){var h=fcHost(),txt=valOf(h)||'',i,base=null;
for(i=0;i<KW.length;i++){if(KW[i][0].test(txt)){base=hex2rgb(KW[i][1]);break}}
if(!base)base=swatchRGB(h);
if(!base)base=hex2rgb('#1C1A18');
var nm=String(txt||'Black').replace(/floating\s*frame(d)?/ig,'').replace(/\s+/g,' ').trim()||'Black';
return{f:'linear-gradient(148deg,'+sh(base,.30)+','+sh(base,.08)+' 45%,'+sh(base,-.15)+')',s:sh(base,-.24),name:nm}}
function face(){var B=window.WKBridge&&window.WKBridge.state;if(B&&B.w&&B.h)return{w:B.w,h:B.h};var V=window.WKVariant&&window.WKVariant.read();var m=String((V&&V.size)||val(C.size)||'').match(/(\d+(?:\.\d+)?)\s*cm/gi);if(!m||m.length<2)return null;var a=parseFloat(m[0]),b=parseFloat(m[1]),s=Math.min(a,b),l=Math.max(a,b);return /landscape/i.test(val(C.ori)||'')?{w:l,h:s}:{w:s,h:l}}
function image(){var h=opt(C.up);if(!h)return null;var im=h.querySelector('img[src]');if(im&&/^(https?:|data:|blob:|\/\/)/.test(im.getAttribute('src')||''))return im.src;var ns=h.querySelectorAll('*'),i,bg;for(i=0;i<ns.length;i++){bg=getComputedStyle(ns[i]).backgroundImage;if(bg&&bg!=='none'&&bg.indexOf('url(')===0)return bg.slice(4,-1).replace(/^["']|["']$/g,'')}return null}
function edgeMode(){var v=(val(C.edge)||'MIRROR').toUpperCase();
/* order matters: "Image Wrap" also contains WRAP, so MIRROR must be tested first */
if(v.indexOf('MIRROR')>-1)return'MIRROR';
if(v.indexOf('WHITE')>-1)return'WHITE';
if(v.indexOf('BLACK')>-1)return'BLACK';
if(v.indexOf('WRAP')>-1||v.indexOf('IMAGE')>-1||v.indexOf('EXTEND')>-1||v.indexOf('FULL')>-1||v.indexOf('BLEED')>-1)return'WRAP';
return'MIRROR'}
function isFramed(){var V=window.WKVariant&&window.WKVariant.read();var v=(V&&V.framing)||val(C.fram)||'';return /float/i.test(v)}
function r2(n){return Math.round(n*100)/100}
function cover(iw,ih,bw,bh){var s=Math.max(bw/iw,bh/ih),w=iw*s,h=ih*s;return{w:w,h:h,x:(bw-w)/2,y:(bh-h)/2}}
/* The photo's real pixel size is needed to reproduce what "cover" does, so cache it per URL.
   Returns null while the probe is still loading and re-renders itself once it lands. */
var IM={},IMn=0;
function natural(u){if(!u)return null;var r=IM[u];if(r)return r.w?r:null;
if(++IMn>12){IM={};IMn=1}
IM[u]={};var im=new Image();
im.onload=function(){IM[u]={w:im.naturalWidth||0,h:im.naturalHeight||0};log('natural',im.naturalWidth+'x'+im.naturalHeight);render('img-loaded')};
im.onerror=function(){IM[u]={w:0,h:0}};
im.src=u;return IM[u].w?IM[u]:null}
var CSS='#wk-pv{margin:0 0 18px;width:100%}#wk-pv .wk-stage{position:relative;display:flex;align-items:center;justify-content:center;height:'+C.stageH+'px;border-radius:10px;overflow:hidden;background:radial-gradient(135% 105% at 50% 118%,#E4DED4 0%,#CDC5B8 42%,#ABA192 100%)}#wk-pv .wk-scene{perspective:1900px;perspective-origin:50% 46%}#wk-pv .wk-rot{transform-style:preserve-3d;transition:transform .22s cubic-bezier(.22,.61,.36,1)}#wk-pv .wk-prod{position:relative;transform-style:preserve-3d}#wk-pv .wk-prod>*{position:absolute}#wk-pv .wk-drop{inset:0;box-shadow:26px 22px 38px -14px #0000003d;transform:translateZ(-3px)}#wk-pv .wk-face{background-size:cover;background-position:center;box-shadow:0 0 0 .5px #00000024}#wk-pv .wk-face.tex:after{content:"";position:absolute;inset:0;opacity:.15;mix-blend-mode:multiply;background-image:repeating-linear-gradient(0deg,#0000,#0000 1px,#00000022 1px,#00000022 2px),repeating-linear-gradient(90deg,#0000,#0000 1px,#00000018 1px,#00000018 2px)}#wk-pv .wk-side{overflow:hidden}#wk-pv .wk-side .i{position:absolute;inset:0;background-size:cover}#wk-pv .wk-side .s{position:absolute;inset:0}#wk-pv .wk-sr{top:0;right:0;height:100%;transform-origin:100% 50%;transform:rotateY(-90deg)}#wk-pv .wk-sr .s{background:#00000024}#wk-pv .wk-sb{left:0;bottom:0;width:100%;transform-origin:50% 100%;transform:rotateX(90deg)}#wk-pv .wk-sb .s{background:#00000036}#wk-pv .wk-gap{overflow:hidden}#wk-pv .wk-empty{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:0 24px;font-size:13px;line-height:1.6;color:#8a8278}#wk-pv .wk-cap{margin-top:7px;font-size:11.5px;color:#8a8278;letter-spacing:.02em;text-align:center}';
function build(){if(built)return true;
/* most canvas products have no photo upload - do not leave a stray preview box there */
if(!opt(C.up))return false;
var first=document.querySelector('[data-option]');if(!first||!first.parentNode)return false;
if(!document.getElementById('wk-pv-css')){var st=document.createElement('style');st.id='wk-pv-css';st.textContent=CSS;document.head.appendChild(st)}
var box=document.createElement('div');box.id='wk-pv';box.style.display='none';
box.innerHTML='<div class="wk-stage"><div class="wk-scene"><div class="wk-rot"><div class="wk-prod"><div class="wk-drop"></div><div class="wk-ff"></div><div class="wk-gap"><div class="wk-gapi"></div></div><div class="wk-face"></div><div class="wk-side wk-sr"><div class="i"></div><div class="s"></div></div><div class="wk-side wk-sb"><div class="i"></div><div class="s"></div></div></div></div></div><div class="wk-empty">Upload a photo to preview your canvas</div></div><div class="wk-cap"></div>';
first.parentNode.insertBefore(box,first);
el.box=box;el.stage=box.querySelector('.wk-stage');el.rot=box.querySelector('.wk-rot');el.prod=box.querySelector('.wk-prod');el.ff=box.querySelector('.wk-ff');el.gap=box.querySelector('.wk-gap');el.gapi=box.querySelector('.wk-gapi');el.face=box.querySelector('.wk-face');el.sr=box.querySelector('.wk-sr');el.sri=box.querySelector('.wk-sr .i');el.sb=box.querySelector('.wk-sb');el.sbi=box.querySelector('.wk-sb .i');el.empty=box.querySelector('.wk-empty');el.cap=box.querySelector('.wk-cap');
built=true;log('mounted');return true}
function render(why){if(!build())return;var f=face(),img=image();
if(!f||!img){el.box.style.display='none';el.cap.textContent='';return}
el.box.style.display='';el.empty.style.display='none';el.prod.style.visibility='visible';
var framed=isFramed(),inset=framed?C.frameCm+C.gapCm:0,ow=f.w+2*inset,oh=f.h+2*inset;
var bw=el.stage.clientWidth||320,bh=el.stage.clientHeight||C.stageH,sc=Math.min((bw-90)/ow,(bh-70)/oh);if(!(sc>0))sc=1;
var px=function(cm){return cm*sc},fw=px(f.w),fh=px(f.h),ip=px(inset),fp=px(C.frameCm),dp=px(framed?C.frameDepthCm:C.depthCm);
var mode=edgeMode(),solid=mode==='WHITE'?'#FFFFFF':mode==='BLACK'?'#0B0B0B':null,skin=framed?frameSkin():null;
/* ---- one background geometry, shared by the face, the sides and the frame gap ----
   The face used to be "cover" while the side bands were stretched to the face size. As
   long as the photo's ratio matched the print ratio nobody noticed, but the moment they
   differ - which is exactly what changing Orientation after upload does - the two scales
   disagree and the picture visibly steps at the fold. So compute the cover box ONCE from
   the photo's real pixel size and let every surface read from it.
   Image Wrap covers the extended print (face + depth on all four sides) instead. */
var ew=fw+2*dp,eh=fh+2*dp,wrap=mode==='WRAP';
var nat=natural(img),bxw=wrap?ew:fw,bxh=wrap?eh:fh,o0=wrap?-dp:0;
var cv=nat?cover(nat.w,nat.h,bxw,bxh):{w:bxw,h:bxh,x:0,y:0};
var BS=r2(cv.w)+'px '+r2(cv.h)+'px',PX=o0+cv.x,PY=o0+cv.y;
el.prod.style.width=px(ow)+'px';el.prod.style.height=px(oh)+'px';
el.face.style.cssText='position:absolute;left:'+ip+'px;top:'+ip+'px;width:'+fw+'px;height:'+fh+'px;background-image:url("'+img+'");background-size:'+BS+';background-position:'+r2(PX)+'px '+r2(PY)+'px;';
el.face.className='wk-face'+(C.texture?' tex':'');
if(framed){
el.ff.style.cssText='position:absolute;inset:0;background:'+skin.f+';';
el.gap.style.cssText='position:absolute;left:'+fp+'px;top:'+fp+'px;right:'+fp+'px;bottom:'+fp+'px;overflow:hidden;box-shadow:inset 0 0 '+Math.max(5,px(0.4))+'px #000000a6,inset 0 0 2px #000000cc;';
/* the gap ring sits px(gapCm) outside the face, so shift the SAME background by that much
   and the canvas edge reads as one continuous picture instead of a second, rescaled copy */
var gp=px(C.gapCm);
el.gapi.style.cssText=(mode==='MIRROR'||wrap)?'position:absolute;inset:0;background-image:url("'+img+'");background-size:'+BS+';background-position:'+r2(PX+gp)+'px '+r2(PY+gp)+'px;filter:brightness(.38) saturate(.85);':'position:absolute;inset:0;background:'+solid+';filter:brightness(.45);';
el.sr.style.background=skin.s;el.sb.style.background=skin.s;el.sri.style.cssText='position:absolute;inset:0;';el.sbi.style.cssText='position:absolute;inset:0;';
}else{el.ff.style.cssText='display:none';el.gap.style.cssText='display:none';
if(mode==='MIRROR'||wrap){el.sr.style.background='transparent';el.sb.style.background='transparent';
/* The side panels are rotated about their INNER edge, so local x=dp (y=dp) is the fold that
   touches the face, and local 0 is the back. Mirrored Wrap therefore reads outward-in and
   needs NO flip; Image Wrap continues past the face edge and does. Both keep the face's
   background-size, which is what makes the seam line up. */
var sx=wrap?(PX-fw):(PX-(fw-dp)),sy=wrap?(PY-fh):(PY-(fh-dp));
el.sri.style.cssText='position:absolute;inset:0;background-image:url("'+img+'");background-size:'+BS+';background-position:'+r2(sx)+'px '+r2(PY)+'px;'+(wrap?'transform:scaleX(-1);':'');
el.sbi.style.cssText='position:absolute;inset:0;background-image:url("'+img+'");background-size:'+BS+';background-position:'+r2(PX)+'px '+r2(sy)+'px;'+(wrap?'transform:scaleY(-1);':'');
}else{el.sr.style.background=solid;el.sb.style.background=solid;el.sri.style.cssText='position:absolute;inset:0;';el.sbi.style.cssText='position:absolute;inset:0;'}}
el.sr.style.width=dp+'px';el.sb.style.height=dp+'px';
var mx=Math.max(f.w,f.h);
var ry=C.ry+Math.max(0,Math.min(C.ryBoost,(mx-C.ryRefCm)*C.ryPerCm));
el.rot.style.transform='rotateX('+C.rx+'deg) rotateY('+(-ry)+'deg)';
el.cap.textContent=f.w+' × '+f.h+' cm · '+({MIRROR:'Mirrored Wrap',WRAP:'Image Wrap',WHITE:'White Edge',BLACK:'Black Edge'}[mode]||mode)+(framed?' · Floating Framed ('+skin.name+')':' · Stretched');
var k=[f.w,f.h,mode,framed,framed?skin.name:'',img.length].join('|');if(k!==lastKey){lastKey=k;log('render',k,why)}}
var t=null;function schedule(w){clearTimeout(t);t=setTimeout(function(){render(w)},60)}
window.addEventListener('option:changed',function(e){schedule('opt:'+(e&&e.detail&&e.detail.name))});
/* belt and braces: LPO's own event is the normal path, but a raw change inside any option
   (Orientation especially) must repaint even if the app's event name ever changes */
document.addEventListener('change',function(e){var t=e.target,h=t&&t.closest&&t.closest('[data-option]');
if(h)schedule('chg:'+h.getAttribute('data-option'))},true);
window.addEventListener('options:rendered',function(){built=false;el={};schedule('rendered')});
window.addEventListener('resize',function(){schedule('resize')});
window.addEventListener('wk:variant',function(){schedule('variant')});
function watchUpload(){var h=opt(C.up);if(!h||h.__wkPv)return;h.__wkPv=1;new MutationObserver(function(){schedule('upload')}).observe(h,{childList:true,subtree:true,attributes:true,attributeFilter:['src','style']});log('watching upload')}
var tries=0;(function boot(){render('init');watchUpload();if(++tries<40)setTimeout(boot,400)})();
function healthy(){var b=document.getElementById('wk-pv');return !!(b&&el.cap&&el.cap.parentNode&&b.contains(el.cap)&&document.body.contains(b))}
setInterval(function(){if(!healthy()){var o=document.getElementById('wk-pv');if(o&&o.parentNode)o.parentNode.removeChild(o);built=false;el={}}render('tick');watchUpload()},1200);
window.WKPreview={cfg:C,render:render,_face:face,_image:image,_val:val,_fc:function(){var h=fcHost();return{option:h&&h.getAttribute('data-option'),value:valOf(h),skin:frameSkin()}}};
})();
/* v1.2.1: LPO re-renders the option list, leaving a stale preview box behind. Keep only the newest. */
(function(){function dd(){var n=document.querySelectorAll('#wk-pv');for(var i=0;i<n.length-1;i++)if(n[i].parentNode)n[i].parentNode.removeChild(n[i])}
window.addEventListener('options:rendered',function(){setTimeout(dd,150)});
var c=0,t=setInterval(function(){dd();if(++c>40)clearInterval(t)},400)})();
/* v1.2.2: Upload-Lift paints its thumbnail into a <canvas>, so there is no <img> for image() to read.
   Mirror the cropped-image URL out of the hidden properties[Photo] field into a hidden <img> that
   the preview layer can pick up, and re-render whenever it changes. */
(function(){var last=null;
function u(){var ins=document.querySelectorAll('input[name^="properties["]'),i,n,v,best=null,orig=null;
for(i=0;i<ins.length;i++){n=ins[i].name||'';v=String(ins[i].value||'');
if(!/^(https?:|data:|blob:)/.test(v))continue;
if(/original/i.test(n)){if(!orig)orig=v;continue}
if(/photo|image|upload|file|art|design/i.test(n)){if(!best)best=v;continue}
if(!best&&/\.(jpe?g|png|webp|gif|avif|tiff?)(\?|$)/i.test(v))best=v}
return best||orig||null}
function sync(){var v=u();if(v===last)return;last=v;
var h=document.querySelector('[data-option="Photo"]');if(!h)return;
var im=document.getElementById('wk-src');
if(!v){if(im&&im.parentNode)im.parentNode.removeChild(im);if(window.WKPreview)WKPreview.render('src-cleared');return}
if(!im){im=document.createElement('img');im.id='wk-src';im.style.cssText='position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';h.appendChild(im)}
im.onload=function(){if(window.WKPreview)WKPreview.render('src-ready')};im.src=v}
setInterval(sync,600);sync()})();
/* ==========================================================================
 * WallKoala - product page layout  v2.5
 * The theme re-renders the product form on variant change, which undoes any
 * DOM move, so everything is re-asserted on a slow tick and is a no-op once
 * each node already sits where it belongs.
 *   1. frame colour option -> directly under the Framing Type picker
 *   2. sales points        -> directly above Add to cart
 *   3. frame colour        -> shown/hidden from the VARIANT, because LPO only
 *                             evaluates its condition on first render and never
 *                             re-hides the option when the customer switches
 *                             back to Stretched. Inputs are disabled while
 *                             hidden so a stretched order never carries a
 *                             frame-colour property. Set DISABLE_WHEN_HIDDEN
 *                             = false if LPO validation objects.
 *   4. live preview        -> DESKTOP: top of the media column, pushing the
 *                             photo gallery down. The gallery is a Flickity
 *                             slider, so we sit above it rather than injecting
 *                             into it. Set HIDE_GALLERY=true for a full
 *                             takeover (photos hidden once the customer's own
 *                             preview is showing).
 *                             PHONE: the media column sits at the very top of
 *                             a one-column page, so by the time the customer
 *                             has finished picking options the preview has
 *                             scrolled well out of sight. On a narrow viewport
 *                             it goes directly above the buy button instead,
 *                             and the gallery keeps its normal position.
 *                             The swap re-runs on resize / rotate.
 * ========================================================================== */
(function(){
var DEBUG=true, HIDE_GALLERY=false, STAGE_H=460, DISABLE_WHEN_HIDDEN=true, MOBILE_MAX=749;
function isMobile(){return window.matchMedia?window.matchMedia('(max-width:'+MOBILE_MAX+'px)').matches:(window.innerWidth<=MOBILE_MAX)}
function log(){if(DEBUG&&window.console)console.debug.apply(console,['[wk-layout]'].concat([].slice.call(arguments)))}

if(!document.getElementById('wk-layout-css')){
  var st=document.createElement('style');st.id='wk-layout-css';
  st.textContent='.wk-moved-sales{margin:14px 0 10px!important}'+
    '.wk-moved-fc{margin:14px 0 4px!important}'+
    '#wk-pv{margin:4px 0 16px!important}'+
    '#wk-pv.wk-in-gallery{margin:0 0 18px!important}'+
    '#wk-pv.wk-in-gallery .wk-stage{height:'+STAGE_H+'px}'+
    /* phone: the preview sits in the form just above the buy button, so keep it
       short enough that the button still lands within reach on one screen */
    '@media (max-width:'+MOBILE_MAX+'px){'+
      '#wk-pv.wk-in-gallery .wk-stage{height:320px}'+
      '#wk-pv:not(.wk-in-gallery) .wk-stage{height:300px}'+
      '#wk-pv:not(.wk-in-gallery){margin:6px 0 14px!important}'+
    '}'+
    '.wk-gallery-hidden{display:none!important}';
  document.head.appendChild(st);
}
function addToCart(){
  var f=document.querySelector('form[action*="/cart/add"]');
  return f&&(f.querySelector('button.add-to-cart')||f.querySelector('button[name=add]')||f.querySelector('[type=submit]'));
}
function mediaColumn(){
  return document.querySelector('.product__photos,.product-single__photos,.product__media-wrapper,.product-single__media-group');
}
function slideshow(){
  return document.querySelector('.product-slideshow,.product-single__photos .flickity-enabled,.product__main-photos');
}
function frameColorOpt(){
  /* the unified framing control wins - otherwise this returns the LEGACY colour row and
     un-hides exactly what the frame control just hid */
  var m=document.querySelector('[data-wk-frame-control]');if(m)return m;
  var a=document.querySelectorAll('[data-option]'),i,n;
  for(i=0;i<a.length;i++){n=a[i].getAttribute('data-option')||'';if(/fram/i.test(n)&&/colou?r/i.test(n))return a[i]}
  return null;
}
function framingWrap(){
  var fs=document.querySelector('fieldset[name="Framing Type"],fieldset[name="Framing type"]');
  if(fs)return fs.closest('.variant-wrapper')||fs;
  // dropdown mode: the theme renders <select data-index="optionN"> instead of a fieldset
  var sels=document.querySelectorAll('.variant-wrapper select,select[data-index]'),i,w,lbl;
  for(i=0;i<sels.length;i++){
    w=sels[i].closest('.variant-wrapper')||sels[i].parentElement;
    lbl=w&&w.textContent||'';
    if(/fram/i.test(lbl))return w;
  }
  return null;
}
function salesBlock(){
  var all=document.querySelectorAll('.product-block--sales-point');
  if(!all.length){var ul=document.querySelector('ul.sales-points');return ul?(ul.closest('.product-block')||ul):null}
  if(all.length>1){for(var i=0;i<all.length-1;i++){if(all[i].parentNode)all[i].parentNode.removeChild(all[i])}}
  return all[all.length-1];
}
function after(n,r){if(!n||!r||!r.parentNode||r.nextElementSibling===n)return false;r.parentNode.insertBefore(n,r.nextSibling);return true}
function before(n,r){if(!n||!r||!r.parentNode||n.nextElementSibling===r)return false;r.parentNode.insertBefore(n,r);return true}

/* LPO shows the frame-colour option when Floating Framed is picked but never
   takes it away again. Drive visibility from the variant on every tick. */
function syncFrameColour(){
  var host=frameColorOpt(); if(!host)return null;
  /* v2.5: when the unified frame control is active the swatch row IS the
     framing picker, so it must stay visible at all times. */
  if(window.WKFrame){ if(host.style.display==='none')host.style.display='';
    [].forEach.call(host.querySelectorAll('input,select,textarea'),function(i){i.disabled=false});
    return host }
  var V=window.WKVariant&&window.WKVariant.read();
  var framed=!!(V&&/float/i.test(V.framing||''));
  if(host.__wkFramed===framed)return host;
  host.__wkFramed=framed;
  host.style.display=framed?'':'none';
  if(DISABLE_WHEN_HIDDEN){
    [].forEach.call(host.querySelectorAll('input,select,textarea'),function(i){i.disabled=!framed});
  }
  log('frame colour ->',framed?'shown':'hidden');
  return host;
}

function layout(){
  var atc=addToCart(); if(!atc)return;
  var moved=[];
  var fc=syncFrameColour(),fw=framingWrap();
  if(fc&&fw){fc.classList.add('wk-moved-fc');if(after(fc,fw))moved.push('frameColour')}
  var sb=salesBlock();
  if(sb){sb.classList.add('wk-moved-sales');if(before(sb,atc))moved.push('salesPoints')}

  var pv=document.getElementById('wk-pv');
  if(pv){
    var media=mediaColumn(),sl=slideshow(),phone=isMobile();
    var showing=getComputedStyle(pv).display!=='none';
    if(media&&!phone){
      pv.classList.add('wk-in-gallery');
      if(media.firstElementChild!==pv){media.insertBefore(pv,media.firstElementChild);moved.push('preview->topOfMedia')}
      if(sl){ if(HIDE_GALLERY&&showing)sl.classList.add('wk-gallery-hidden');
              else sl.classList.remove('wk-gallery-hidden'); }
    }else{
      /* phone (or no media column at all): sit in the form, above the sales points,
         which are themselves already directly above Add to cart */
      pv.classList.remove('wk-in-gallery');
      if(sl)sl.classList.remove('wk-gallery-hidden');
      var anchor=(sb&&sb.parentNode)?sb:atc;
      if(before(pv,anchor))moved.push(phone?'preview->aboveATC(phone)':'preview->aboveATC');
    }
  }
  if(moved.length)log('moved',moved.join(', '));
}
/* rotating the phone or resizing the window flips which side of the breakpoint we are on */
var vt=null;
function onViewport(){clearTimeout(vt);vt=setTimeout(layout,150)}
window.addEventListener('resize',onViewport);
window.addEventListener('orientationchange',onViewport);
window.addEventListener('wk:variant',function(){setTimeout(layout,120)});
window.addEventListener('options:rendered',function(){setTimeout(layout,150)});
window.addEventListener('option:changed',function(){setTimeout(layout,120)});
setInterval(layout,900);
layout();
window.WKLayout={layout:layout,syncFrameColour:syncFrameColour,_atc:addToCart,_media:mediaColumn,_fc:frameColorOpt,_fw:framingWrap,_sales:salesBlock,
  isMobile:isMobile,
  breakpoint:function(v){if(v)MOBILE_MAX=v;return MOBILE_MAX},
  hideGallery:function(v){HIDE_GALLERY=!!v;layout()}};
})();
/* ==========================================================================
 * WallKoala - unified framing control  v2.5
 * The LPO swatch row becomes the single framing control: "Stretched" plus the
 * frame colours. Clicking a swatch does NOT try to own the variant - it just
 * remote-controls the theme's native Framing Type picker, which still owns the
 * variant id and price. Two-way, with a re-entrancy lock.
 *
 * SAFETY: the native picker is hidden ONLY after this script has proven it can
 * keep the two in sync. If the script never loads or never aligns them, the
 * native picker stays visible and the customer can still order correctly.
 * ========================================================================== */
(function(){
var DEBUG=true, HIDE_NATIVE=true, LOCK_MS=1400;
var busy=false, wired=false, lastColour=null;
function log(){if(DEBUG&&window.console)console.debug.apply(console,['[wk-frame]'].concat([].slice.call(arguments)))}
function lock(){busy=true;setTimeout(function(){busy=false},LOCK_MS)}

/* the LPO option that carries Stretched + the colours (any name containing "fram") */
function mark(e){if(e&&!e.hasAttribute('data-wk-frame-control'))e.setAttribute('data-wk-frame-control','');return e}
function host(){var a=document.querySelectorAll('[data-option]'),i,n,e;
  for(i=0;i<a.length;i++){e=a[i];n=e.getAttribute('data-option')||'';
    if(!/fram/i.test(n))continue;
    /* The unified control is DEFINED by offering Stretched alongside the colours.
       Requiring it does two jobs: a legacy colour-only row (an older option set still
       targeting this product) no longer wins just by coming first in the DOM, and if
       the real row ever fails to render we return null instead of latching onto that
       legacy row - which would leave the customer no way to pick framing at all. */
    if(/stretch/i.test(e.textContent||''))return mark(e);
  }
  return null}
/* Any OTHER framing/colour option on the page comes from a second option set. Mirror the
   chosen colour into it so LPO's "required" validation stays satisfied, then hide it:
   two framing rows side by side is the most confusing thing that can happen here.
   Removing the stale option set in LPO is the real fix - this only stops the bleeding. */
var hiddenDupes=[];
function hideLegacy(){
  var ctrl=host();
  if(!ctrl){  /* the unified row is gone - put back whatever we hid, then let tick()
                 restore the native picker. Never leave the page with no framing control. */
    hiddenDupes.forEach(function(e){if(e.style.display==='none')e.style.display=''});
    if(hiddenDupes.length)log('no unified control - restored '+hiddenDupes.length+' duplicate row(s)');
    hiddenDupes=[];return}
  var p=picked(),a=document.querySelectorAll('[data-option]'),i,n,e;
  for(i=0;i<a.length;i++){e=a[i];if(e===ctrl)continue;
    n=e.getAttribute('data-option')||'';
    if(!/fram/i.test(n)||!/colou?r/i.test(n))continue;
    if(p&&!isStretch(p.text)){
      var want=[].filter.call(e.querySelectorAll('input[type=radio],input[type=checkbox]'),function(x){
        var l=x.closest('label');return ((l&&l.textContent)||x.value||'').replace(/\s+/g,' ').trim()===p.text})[0];
      /* .click() on a label inside a display:none subtree does NOT forward to the input
         in Chrome, so set the state directly and announce it */
      if(want&&!want.checked){want.checked=true;
        want.dispatchEvent(new Event('input',{bubbles:true}));
        want.dispatchEvent(new Event('change',{bubbles:true}));}
    }
    if(e.style.display!=='none'){e.style.display='none';
      if(hiddenDupes.indexOf(e)<0)hiddenDupes.push(e);
      log('hid duplicate framing option "'+n+'"')}
  }}
/* The theme's own framing picker, dropdown or button mode. Found by its VALUES
   (one stretched + one floating), never by its name: across this catalogue the
   option is called "Framing Type" on most products and "Format" on others. */
function isFramingText(t){return /stretch/i.test(t||'')&&/float/i.test(t||'')}
function native(){
  var ws=document.querySelectorAll('.variant-wrapper'),i,w,sel,fs;
  for(i=0;i<ws.length;i++){w=ws[i];
    if(!isFramingText(w.textContent))continue;
    sel=w.querySelector('select');if(sel)return{sel:sel,wrap:w};
    fs=w.querySelector('fieldset');if(fs)return{fs:fs,wrap:w};
  }
  /* pickers rendered outside a .variant-wrapper */
  var ss=document.querySelectorAll('select[data-index],select[name^="options"]');
  for(i=0;i<ss.length;i++){if(isFramingText(ss[i].textContent))return{sel:ss[i],wrap:ss[i].parentElement}}
  var fss=document.querySelectorAll('fieldset[name]');
  for(i=0;i<fss.length;i++){if(isFramingText(fss[i].textContent))return{fs:fss[i],wrap:fss[i].closest('.variant-wrapper')||fss[i]}}
  return null}
/* the native picker's values, as {v:submitted value, t:visible text} */
function nativeValues(n){
  if(n.sel)return [].map.call(n.sel.options,function(o){return{el:o,v:o.value,t:o.textContent||o.value}});
  return [].map.call(n.fs.querySelectorAll('input'),function(i){var l=i.closest('label');
    return{el:i,v:i.value,t:((l&&l.textContent)||i.value)}})}
/* Some canvas products put the frame COLOUR in the variant itself
   ("Floating Frame Black/White/Birch"); others only have "Floating Framed" and the
   colour travels as an LPO property. One keyword list serves both. */
var COLOURS=[/black|noir|onyx/i,/white|ivory|blanc/i,/birch|champagne/i,/oak|natural|maple/i,
  /walnut|espresso/i,/silver|chrome|alumin/i,/grey|gray|graphite/i,/gold|brass/i];
function colourOf(t){for(var i=0;i<COLOURS.length;i++){if(COLOURS[i].test(t||''))return COLOURS[i]}return null}
function swatches(){var h=host();if(!h)return[];
  return [].map.call(h.querySelectorAll('input[type=radio],input[type=checkbox]'),function(i){
    var l=i.closest('label');return{input:i,text:((l&&l.textContent)||i.value||'').replace(/\s+/g,' ').trim()}})}
function isStretch(t){return /stretch/i.test(t||'')}
function picked(){var s=swatches(),i;for(i=0;i<s.length;i++)if(s[i].input.checked)return s[i];return null}
function variantFraming(){var V=window.WKVariant&&window.WKVariant.read();return (V&&V.framing)||null}
function variantFramed(){var v=variantFraming();return v? /float/i.test(v) : null}

/* ---- swatch -> native variant ---------------------------------------- */
function driveNative(swatchText){
  var n=native();if(!n)return false;
  var vals=nativeValues(n),framed=!isStretch(swatchText),col=framed?colourOf(swatchText):null,hit=null;
  /* If the native picker carries the colour, land on the EXACT colour variant -
     falling back to "first floating value" would silently ship Black for every colour. */
  if(col)hit=vals.filter(function(x){return /float/i.test(x.t)&&col.test(x.t)})[0];
  if(!hit)hit=vals.filter(function(x){return framed?/float/i.test(x.t):/stretch/i.test(x.t)})[0];
  if(!hit)return false;
  if(n.sel){
    if(n.sel.value===hit.v)return false;
    n.sel.value=hit.v;n.sel.dispatchEvent(new Event('change',{bubbles:true}));return true;
  }
  if(hit.el&&!hit.el.checked){(hit.el.closest('label')||hit.el).click();return true}
  return false}
function onSwatchChange(e){
  var h=host();if(!h||!e.target||!h.contains(e.target))return;
  if(busy)return;
  var p=picked();if(!p)return;
  if(!isStretch(p.text))lastColour=p.text;
  lock();
  if(driveNative(p.text))log('swatch "'+p.text+'" -> native variant');
}
document.addEventListener('change',onSwatchChange,true);
document.addEventListener('click',function(e){setTimeout(function(){onSwatchChange(e)},80)},true);

/* ---- native variant -> swatch ---------------------------------------- */
function syncFromVariant(){
  if(busy)return;
  var framed=variantFramed();if(framed===null)return;
  var s=swatches();if(!s.length)return;
  var cur=picked(),want=null;
  if(!framed){ want=s.filter(function(x){return isStretch(x.text)})[0] }
  else {
    /* when the colour is part of the variant, mirror THAT colour onto the swatch */
    var col=colourOf(variantFraming());
    if(col)want=s.filter(function(x){return !isStretch(x.text)&&col.test(x.text)})[0];
    if(!want){
      if(cur&&!isStretch(cur.text)){wired=true;return}        // already on a colour
      want=s.filter(function(x){return x.text===lastColour})[0]
        || s.filter(function(x){return !isStretch(x.text)})[0];
    }
  }
  if(!want)return;
  if(want.input.checked){wired=true;return}                    // already aligned
  lock();(want.input.closest('label')||want.input).click();
  log('variant -> swatch "'+want.text+'"');
  setTimeout(function(){if(picked()&&picked().input===want.input)wired=true},300);
}
window.addEventListener('wk:variant',function(){setTimeout(syncFromVariant,160)});

/* ---- tick: keep in sync, hide native only once proven ----------------- */
/* theme.liquid hides the native picker and any legacy colour row BEFORE first paint,
   so the page never flashes the controls we are about to replace. That stylesheet is a
   promise this script has to keep: the moment we know the swatch row is not coming,
   drop it so the customer still has a working picker. */
function dropPreboot(why){var s=document.getElementById('wk-preboot');
  if(s&&s.parentNode){s.parentNode.removeChild(s);log('preboot stylesheet dropped -',why)}}
function lpoRendered(){return !!document.querySelector('.cl-po--wrapper,[data-option]')}
var bootT=Date.now();
/* Called only when there is no framing swatch row. Decide as EARLY as is safe whether
   one is still coming - every millisecond here is a millisecond the customer has no
   framing picker at all, so do not just sit on a long timeout. */
function prebootGuard(){
  if(!document.getElementById('wk-preboot'))return;
  if(lpoRendered())return dropPreboot('LPO rendered without a framing swatch row');
  if(!(window.Cloudlift&&window.Cloudlift.options)){
    if(Date.now()-bootT>2500)dropPreboot('Live Product Options is not on this page');
    return}
  if(Date.now()-bootT>6000)dropPreboot('timed out waiting for the swatch row');
}
function tick(){
  var n=native();
  if(!n)return;
  var h=host();
  hideLegacy();            /* handles the "no control" case itself */
  if(!h){   /* swatch row gone (LPO failed to render?) - the native picker MUST come back */
    prebootGuard();
    if(n.wrap&&n.wrap.style.display==='none'){n.wrap.style.display='';log('swatch row missing - restored native picker')}
    wired=false;return;
  }
  syncFromVariant();
  if(n.wrap){
    if(HIDE_NATIVE&&wired){ if(n.wrap.style.display!=='none')n.wrap.style.display='none' }
    else { if(n.wrap.style.display==='none')n.wrap.style.display='' }
  }
}
setInterval(tick,700);tick();
window.WKFrame={tick:tick,isWired:function(){return wired},
  showNative:function(){HIDE_NATIVE=false;dropPreboot('showNative()');tick()},
  hideNative:function(){HIDE_NATIVE=true;tick()},
  _host:host,_native:native,_nativeValues:nativeValues,_swatches:swatches,_picked:picked,
  _colourOf:colourOf,_drive:driveNative,_dropPreboot:dropPreboot};
})();
/* ==========================================================================
 * WallKoala - crop/size mismatch notice  v2.8
 * Upload-Lift validates the stored crop against the current print size at
 * ADD-TO-CART time and force-opens the image editor. Cancelling that editor
 * discards the upload entirely. Both were verified on the live product page.
 *
 * This module moves the conversation earlier: the moment the crop no longer
 * matches the selected size, it says so inline with a "Re-crop" button, so
 * the customer never meets the modal at checkout time. It also caches the
 * uploaded URLs and puts them back if they get cleared WITHOUT a deliberate
 * Remove click - with a visible notice, never silently.
 * ========================================================================== */
(function(){
var DEBUG=true, TOL=0.02, POLL=800, RESTORE=true;
var cache={photo:null,original:null,photoName:null,originalName:null}, ratioOf={}, userRemoved=0, noticeMode=null, justRestored=false;
function log(){if(DEBUG&&window.console)console.debug.apply(console,['[wk-recrop]'].concat([].slice.call(arguments)))}
function photoHost(){return document.querySelector('[data-option="Photo"]')||
  (function(){var a=document.querySelectorAll('[data-option]');for(var i=0;i<a.length;i++){
    if(a[i].querySelector('input[type=file]'))return a[i]}return null})()}
function propInputs(){
  var h=photoHost();if(!h)return{};
  var o={};
  [].forEach.call(h.querySelectorAll('input[name^="properties["]'),function(i){
    if(/original/i.test(i.name))o.original=i; else if(/photo|image|upload/i.test(i.name))o.photo=i});
  return o}
function urls(){var p=propInputs();
  var ok=/^(https?:|data:|blob:)/;
  return {photo:(p.photo&&ok.test(p.photo.value))?p.photo.value:null,
          original:(p.original&&ok.test(p.original.value))?p.original.value:null}}
function target(){var s=window.WKBridge&&window.WKBridge.state;return (s&&s.w&&s.h)?s.w/s.h:null}

/* measure the stored crop's aspect from the file itself */
function cropRatio(u,cb){
  if(!u)return cb(null);
  if(ratioOf[u]!==undefined)return cb(ratioOf[u]);
  var im=new Image();
  im.onload=function(){ratioOf[u]=im.naturalWidth/im.naturalHeight;cb(ratioOf[u])};
  im.onerror=function(){ratioOf[u]=null;cb(null)};
  im.src=u}

/* ------------------------------- notice ------------------------------- */
function css(){
  if(document.getElementById('wk-recrop-css'))return;
  var s=document.createElement('style');s.id='wk-recrop-css';
  s.textContent='#wk-recrop{margin:10px 0 2px;padding:11px 13px;border-radius:8px;font-size:13px;line-height:1.5;'+
    'display:flex;gap:12px;align-items:center;flex-wrap:wrap}'+
    '#wk-recrop.warn{background:#FDF3E3;border:1px solid #E8CFA0;color:#6B4E12}'+
    '#wk-recrop.info{background:#EAF4EC;border:1px solid #B8D9C0;color:#245C33}'+
    '#wk-recrop button{border:1px solid currentColor;background:transparent;color:inherit;'+
    'padding:6px 13px;border-radius:6px;font-size:12.5px;cursor:pointer;font-family:inherit}'+
    '#wk-recrop button:hover{background:rgba(0,0,0,.06)}';
  document.head.appendChild(s)}
/* The Upload-Lift crop control. Target it BY CLASS, innermost first:
   - .cl-po--crop-label      <span>, the element that actually carries the handler
   - .cl-po--upload-lift-crop <label> wrapper
   Text matching was a trap: our own "Re-crop photo" button matches /crop photo/
   and outranked the real control, so the button clicked itself and did nothing. */
function cropNodes(){
  var notice=document.getElementById('wk-recrop');
  function usable(n){
    if(notice&&notice.contains(n))return false;
    var r=n.getBoundingClientRect();return !!(r.width||r.height);
  }
  var direct=[].filter.call(document.querySelectorAll('.cl-po--crop-label,.cl-po--upload-lift-crop'),usable);
  if(direct.length){direct.sort(function(a,b){return a.children.length-b.children.length});return direct}
  /* fallback for other builds: text match, innermost, never our own notice */
  var re=/edit\s*\/\s*crop|edit\s*photo/i;
  var all=[].filter.call(document.querySelectorAll('button,a,[role=button],label,span'),function(n){
    var t=(n.textContent||'').replace(/\s+/g,' ').trim();
    return re.test(t)&&t.length<60&&usable(n);
  });
  return all.filter(function(n){return !all.some(function(m){return m!==n&&n.contains(m)})});
}
function cropButton(){return cropNodes()[0]||null}
/* Doka is the editor library Upload-Lift embeds - its root node is the only
   reliable "editor is open" signal. A generic full-screen-overlay check gives
   false positives on this theme. */
function editorOpen(){return !!document.querySelector('[class*="doka" i],[class*="pintura" i]')}
function fire(el){
  ['pointerdown','mousedown','mouseup','click'].forEach(function(t){
    try{el.dispatchEvent(new MouseEvent(t,{bubbles:true,cancelable:true,view:window}))}catch(e){}});
  try{if(el.click)el.click()}catch(e){}}
function openCropEditor(){
  var list=cropNodes();
  if(!list.length){log('crop control not found');return false}
  log('clicking crop control',list[0].tagName,String(list[0].className).slice(0,40));
  fire(list[0]);
  var i=1;
  var iv=setInterval(function(){
    if(editorOpen()||i>=list.length){clearInterval(iv);
      if(!editorOpen())log('editor did not open');return}
    log('retry on',list[i].tagName);fire(list[i++]);
  },700);
  return true}
function showNotice(mode,text,btnText){
  css();
  var h=photoHost();if(!h)return;
  var box=document.getElementById('wk-recrop');
  if(!box){box=document.createElement('div');box.id='wk-recrop';h.appendChild(box)}
  if(box.parentNode!==h)h.appendChild(box);
  if(noticeMode===mode+'|'+text)return;
  noticeMode=mode+'|'+text;
  box.className=mode;
  box.innerHTML='<span style="flex:1 1 220px"></span>';
  box.firstChild.textContent=text;
  if(btnText){
    var b=document.createElement('button');b.type='button';b.textContent=btnText;
    b.onclick=function(ev){ev.preventDefault();ev.stopPropagation();openCropEditor()};
    box.appendChild(b);
  }
  log('notice:',mode,text)}
function hideNotice(){var box=document.getElementById('wk-recrop');
  if(box&&box.parentNode){box.parentNode.removeChild(box);noticeMode=null}}

/* --------------------------- deliberate remove ------------------------- */
document.addEventListener('click',function(e){
  var h=photoHost();if(!h||!e.target||!h.contains(e.target))return;
  var t=(e.target.textContent||'').replace(/\s+/g,' ').trim();
  if(/^(remove|delete|clear|×|✕)$/i.test(t)||/remove/i.test(e.target.className||'')){
    userRemoved=Date.now();cache={photo:null,original:null,photoName:null,originalName:null};justRestored=false;hideNotice();log('user removed the file')}
},true);

/* Only ONE photo may reach the cart. If several photo properties end up on the
   form (different naming schemes, a stale restore, a re-initialised widget),
   keep the one Upload-Lift is actively maintaining and disable the rest -
   disabled fields are not submitted, so the line item carries exactly one. */
function dedupe(){
  var h=photoHost();if(!h)return;
  function group(re){
    return [].filter.call(h.querySelectorAll('input[name^="properties["]'),function(i){
      return re.test(i.name)&&/^(https?:|data:|blob:)/.test(String(i.value||''))});
  }
  [[/original/i,'original'],[/photo|image|upload/i,'photo']].forEach(function(g){
    var list=group(g[0]).filter(function(i){
      return g[1]==='photo' ? !/original/i.test(i.name) : true});
    if(list.length<2)return;
    /* prefer the field Upload-Lift owns over anything we restored */
    var own=list.filter(function(i){return !i.hasAttribute('data-wk-restored')});
    var keep=(own.length?own:list)[own.length?own.length-1:list.length-1];
    list.forEach(function(i){ i.disabled=(i!==keep) });
    log('deduped '+g[1]+': kept '+keep.name+', disabled '+(list.length-1));
  });
}

/* ------------------------------- main tick ----------------------------- */
function tick(){
  var h=photoHost();if(!h)return;
  var u=urls(), tr=target();

  dedupe();
  if(u.photo){
    /* a genuinely new file/crop clears the "restored" state */
    if(cache.photo && u.photo!==cache.photo) justRestored=false;
    cache.photo=u.photo; cache.original=u.original||cache.original;
    var pi=propInputs();
    if(pi.photo)cache.photoName=pi.photo.name;
    if(pi.original)cache.originalName=pi.original.name;
    if(tr===null)return;
    cropRatio(u.photo,function(cr){
      var mismatch = (cr!==null) && (Math.abs(cr-tr)/tr > TOL);
      if(justRestored){
        /* the upload widget shows an empty box after a restore - always explain */
        showNotice('info',
          'Your photo was cleared when the crop was cancelled, so we put it back. The upload box above may look empty, but your photo is attached.'+
          (mismatch?' It still needs re-cropping for the size you have chosen.':''),
          mismatch?'Re-crop photo':null);
      } else if(mismatch){
        showNotice('warn',
          'Your photo is cropped for a different size. Re-crop it to fit the size you have chosen - otherwise you will be asked to do this when you add to cart.',
          'Re-crop photo');
      } else hideNotice();
    });
    return;
  }

  /* photo gone - was it a deliberate Remove? */
  if(Date.now()-userRemoved < 8000){hideNotice();return}
  if(!RESTORE||!cache.photo)return;
  var p=propInputs();
  if(!p.photo){
    /* reuse the EXACT name Upload-Lift used - hard-coding "Photo_1" here put a
       second photo property on the line item when the real field was "Photo" */
    if(!cache.photoName){log('no cached property name - not restoring');return}
    var i=document.createElement('input');i.type='hidden';i.name=cache.photoName;
    i.setAttribute('data-wk-restored','');h.appendChild(i);p.photo=i;
  }
  if(!p.original&&cache.original&&cache.originalName){
    var j=document.createElement('input');j.type='hidden';j.name=cache.originalName;
    j.setAttribute('data-wk-restored','');h.appendChild(j);p.original=j;
  }
  if(p.photo.value!==cache.photo){
    p.photo.value=cache.photo;
    if(p.original&&cache.original)p.original.value=cache.original;
    justRestored=true;
    log('restored cleared photo props');
  }
  showNotice('info',
    'Your photo was cleared when the crop was cancelled - we have put it back. Please re-crop it for the size you have chosen.',
    'Re-crop photo');
}
setInterval(tick,POLL);tick();
window.WKRecrop={tick:tick,dedupe:dedupe,cache:function(){return cache},_urls:urls,_target:target,open:openCropEditor,_nodes:cropNodes,_editorOpen:editorOpen,
  setRestore:function(v){RESTORE=!!v},_host:photoHost,_cropBtn:cropButton};
})();
